/* @flow */

export const createReducer: Function = (
    initialState: Object,
    reducerMap: Array<any>
): Object => {
    return (state = initialState, action) => {
        const reducer = reducerMap[action.type];
        return reducer ? reducer(state, action) : state;
    };
};



// WEBPACK FOOTER //
// ./src/utils/reducers.js